module.exports = _.noop;


//////////////////
// WEBPACK FOOTER
// external "_.noop"
// module id = 85
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard